import { mapState, mapGetters } from "vuex";

export default {
    data(){
        return {
        }
    },

    computed: {
        ...mapGetters([
            "actionURL"
        ]),
        query: {
            get() {
                return this.$store.state.query;
            },
            set(value) {
                this.$store.commit("setQuery", value);
            }
        },
    },

    methods: {
        submit () {
            window.location.href = this.actionURL;
        },
        reset(){
          this.$store.state.query = "";
        }
    },

    mounted(){
        console.log('loaded GlobalSearchForm');
    }
}
